import React, { Component } from 'react';
class Navbar extends Component {

  render() {
    return (
      <nav>
          <img alt="Forest Hills Cemetery" src="./images/ForestHillsCemeteryBanner.png" />
          <ul id="menu">
              <li><a href="/">Home Page</a></li>
              <li><a href="/search">Search Records</a></li>
              <li><a href="/contact">Contact Us</a></li>
              <li></li>
          </ul>
      </nav>
    );
  }
}

export default Navbar
